import axios from "axios";
import { API } from "configs/api";

export const smsEligibilityApi = {
  getSmsEligibility: (params) => axios.get(API.smsEligibility, { token: true, params }),
  exportSmsEligibility: (params) => axios.get(API.smsEligibilityExport, { token: true, params, responseType: "blob" }),
};
